import { useMemo } from 'react'

export default function useGetLastPath(pathname: string): string {
    const segments = pathname.split('/').filter(Boolean)
    const lastPath = segments.pop() || ''
    return useMemo(() => lastPath, [pathname])
}
